<template>
  <div class="header-infos">
    <AvatarEdit
      class="avatar"
      size="small"
      :member-id="context.memberId"
      :editable="true"
    />
    <div class="infos">
      <div class="name">{{ user.fullName }}</div>
      <div v-if="profile.displayEmail" class="email">{{ user.email }}</div>
    </div>
  </div>
</template>
<script setup lang="ts">
const context = useContextStore();
const user = useUserStore();
const profile = useProfileStore();
</script>
<style lang="scss" scoped>
.header-infos {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: var(--gap_n);
  max-width: stretch;
  @include desktop {
    align-items: flex-start;
    justify-content: flex-start;
  }
}
.infos {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  max-width: stretch;
  padding: 0.6rem 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  gap: var(--gap_xss);
  @include desktop {
    text-align: left;
  }
  .name {
    @include font('l', '900');

    flex: 1;

    // width: stretch;
    max-width: stretch;
    overflow: hidden;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    @include desktop {
      text-align: left;
    }
  }
  .email {
    @include font('s', '600');

    flex: 1;

    // width: stretch;
    max-width: stretch;
    overflow: hidden;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    @include desktop {
      text-align: left;
    }
  }
}
:deep(.content) {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: var(--gap_n);
}
</style>
